
import "./index.css";
import UIComponent from "../common/UIComponent";
import H5FullScreenBtn from "./fullscreenBtn";
import H5PlayBtn from "./playBtn";
import H5Progress from "./h5progress";
import H5CurrentTime from "./h5currentTime";
import H5Duration from "./h5duration";
export default class H5Component extends UIComponent {
  constructor(elementId, interfaces) {
    super();
    this.elementId = elementId;
    this.interfaces = interfaces;
    this.init();
  }

  init() {
    this.shadow = document.createElement("div");
    this.shadow.setAttribute("class", "vhallPlayerh5-shadow");

    this.UIMain = document.createElement("div");
    this.UIMain.setAttribute("class", "vhallPlayerh5-container");

    this.shadow.appendChild(this.UIMain);
    this.appendChild(this.elementId, this.shadow);

    new H5PlayBtn(".vhallPlayerh5-container", this.interfaces);
    this.interfaces.isLive ? undefined : new H5CurrentTime(".vhallPlayerh5-container", this.interfaces);
    this.interfaces.isLive ? undefined : new H5Progress(".vhallPlayerh5-container", this.interfaces);
    this.interfaces.isLive ? undefined : new H5Duration(".vhallPlayerh5-container", this.interfaces);
    new H5FullScreenBtn(".vhallPlayerh5-container", this.interfaces);

    this.timer = setTimeout(() => {
      this.shadow.classList.add("hide");
    }, 5000);

    document.querySelector(`${this.elementId}`).ontouchmove = this.toggleControl.bind(this)

    document.querySelector(`${this.elementId}`).ontouchstart = this.toggleControl.bind(this)
  }

  toggleControl() {
    this.shadow.classList.remove("hide");
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.shadow.classList.add("hide");
    }, 5000)
  }

}